import { forwardRef } from "react";
import { Chain } from "@swapkit/core";
import { cva, type VariantProps } from "class-variance-authority";

import { ForgePrice } from "@coinbot/forge-api/models";

import { runeIconColor } from "~/assets";
import { cn } from "~/services/shadcn";
import { Price } from "./Price";

const priceWithCurrencyVariants = cva("flex flex-col text-end", {
  variants: {
    size: {
      default: "text-sm md:text-base space-y-0.5",
      lg: "text-lg space-y-1",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

interface PriceWithCurrencyProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof priceWithCurrencyVariants> {
  asChild?: boolean;
  price?: ForgePrice;
}

export const PriceWithCurrency = forwardRef<HTMLDivElement, PriceWithCurrencyProps>(
  ({ className, size, price, ...props }, ref) => (
    <div className={cn(priceWithCurrencyVariants({ size }), className)} ref={ref} {...props}>
      {price?.rune !== undefined && (
        <Price
          className="space-x-1"
          value={price.rune > 0 ? price.rune : 0}
          chain={Chain.THORChain}
          srcIcon={runeIconColor}
        />
      )}

      {price?.usd !== undefined && (
        <div className="text-[#F7FAFD]/50">${(price.usd > 0 ? price.usd : 0).toFixed(2)}</div>
      )}
    </div>
  ),
);

PriceWithCurrency.displayName = "PriceWithCurrency";
